import { render, staticRenderFns } from "./AdminSidebar.vue?vue&type=template&id=b3c3344a&scoped=true&"
import script from "./adminSidebar.ts?vue&type=script&lang=ts&"
export * from "./adminSidebar.ts?vue&type=script&lang=ts&"
import style0 from "./AdminSidebar.vue?vue&type=style&index=0&id=b3c3344a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c3344a",
  null
  
)

export default component.exports